import createReducer from 'reducers/createReducer';

import { ClientStatusInfo } from 'actions/actionTypes';
import moment from "moment";

const INITIAL_STATE = {
    clientGuid: '',
    data: {
        clientName: '',
        clientTypeCode: '',
        clientKioskTypeCode: '',
        clientOrder: 0,
        realTimeStatusCode: '',
        realTimeStatus: '',
        startTime: '',
        endTime: '',
        usageTime: 0,
        isContentLimit: false,
        paymentTypeCode: 1,
        paymentType: '',
        gameMode: 'Stroke',
        gameTypeLimitCode: 1,
        gameTypeLimit: '',
        gameHoleTypeLimit: 18,
        playerCountLimit: null,
        drivingRangeTimeLimit: null,
        extendedTimeLimit: null,
        serviceTimeLimit: null,
        gameRoundId: null,
        loginPlayerCount: null,
        courseName: null,
        completeHoleCount: null,
        playHoleNumber: null,
        gameRoundEstimatedEndTime: '',
        gameRoundSetting: {
            concede: 0,
            holeCupLocation: 0,
            mulliganCount: 0,
            useSwingPlate: 0,
            distanceUnit: 0,
            greenLocation: 0,
            greenSpeed: 0,
            greenHardness: 0,
            windSpeed: 0,
            isUseGuideDistance: true,
            maxScoreFactor: 2,
        },
        coursePlanId: '',
        isUpdate: '',
    },
    limitSetting: {
        paymentType: 1,
        usageTime: 3600,
        isContentLimit: false,
        gameMode: 'Stroke',
        gameTypeLimit: 1,
        gameHoleTypeLimit: 18,
        playerCountLimit: 1,
        drivingRangeTimeLimit: 0,
    },
    error: {
        triggered: false,
        message: '',
    },
};

const reducer = createReducer(INITIAL_STATE, {
    // 이벤트
    [ClientStatusInfo.CHANGE_CLIENT_INFO]: (state, action) => {
        let gameMode = 'NoLimit';
        if (action.payload.gameTypeLimitCode === 1 || action.payload.gameTypeLimitCode === 2) {
            gameMode = 'Stroke';
        } else if (action.payload.gameTypeLimitCode === 0 || action.payload.gameTypeLimitCode === 3 || action.payload.gameTypeLimitCode === 4 || action.payload.gameTypeLimitCode === 5) {
            gameMode = 'DrivingRange';
        }

        state.clientGuid = action.payload.clientGuid;
        state.data.clientName = action.payload.clientName;
        state.data.clientTypeCode = action.payload.clientTypeCode;
        state.data.clientKioskTypeCode = action.payload.clientKioskTypeCode;
        state.data.clientOrder = action.payload.clientOrder;
        state.data.realTimeStatusCode = action.payload.realTimeStatusCode;
        state.data.realTimeStatus = action.payload.realTimeStatus;
        state.data.startTime = action.payload.startTime;
        state.data.endTime = action.payload.endTime;
        state.data.usageTime = action.payload.usageTime;
        state.data.isContentLimit = action.payload.isContentLimit;
        state.data.paymentTypeCode = action.payload.paymentTypeCode;
        state.data.paymentType = action.payload.paymentType;
        state.data.gameMode = gameMode;
        state.data.gameTypeLimitCode = action.payload.gameTypeLimitCode;
        state.data.gameTypeLimit = action.payload.gameTypeLimit;
        state.data.gameHoleTypeLimit = action.payload.gameHoleTypeLimit;
        state.data.playerCountLimit = action.payload.playerCountLimit;
        state.data.drivingRangeTimeLimit = action.payload.drivingRangeTimeLimit;
        state.data.extendedTimeLimit = action.payload.extendedTimeLimit;
        state.data.serviceTimeLimit = action.payload.serviceTimeLimit;
        state.data.gameRoundId = action.payload.gameRoundId;
        state.data.loginPlayerCount = action.payload.loginPlayerCount;
        state.data.courseName = action.payload.courseName;
        state.data.completeHoleCount = action.payload.completeHoleCount;
        state.data.playHoleNumber = action.payload.playHoleNumber;
        state.data.gameRoundEstimatedEndTime = action.payload.gameRoundEstimatedEndTime;
        state.data.coursePlanId = action.payload.coursePlanId;
        state.data.isUpdate = moment();

        if (action.payload.realTimeStatusCode !== 'real_time_status_cd:blind') {
            state.limitSetting.paymentType = action.payload.paymentTypeCode;
            state.limitSetting.usageTime = action.payload.usageTime;
            state.limitSetting.isContentLimit = action.payload.isContentLimit;
            state.limitSetting.gameMode = gameMode;
            state.limitSetting.gameTypeLimit = action.payload.gameTypeLimitCode;
            state.limitSetting.gameHoleTypeLimit = action.payload.gameHoleTypeLimit;
            state.limitSetting.playerCountLimit = action.payload.playerCountLimit;
            state.limitSetting.drivingRangeTimeLimit = action.payload.drivingRangeTimeLimit;
        }
    },
    [ClientStatusInfo.CHANGE_GAME_ROUND_SETTING]: (state, action) => {
        state.data.gameRoundSetting[action.payload.name] = action.payload.value;
    },
    [ClientStatusInfo.CHANGE_CLIENT_LIMIT_SETTING]: (state, action) => {
        state.limitSetting[action.payload.name] = action.payload.value;
    },
    [ClientStatusInfo.CHANGE_REAL_TIME_CONTROL_OPTION_DEFAULT_SETTING]: (state, action) => {
        state.limitSetting.paymentType = action.payload.paymentType;
        state.limitSetting.usageTime = action.payload.usageTime;
        state.limitSetting.isContentLimit = action.payload.isContentLimit;
        state.limitSetting.gameMode = action.payload.gameMode;
        state.limitSetting.gameTypeLimit = action.payload.gameTypeLimit;
        state.limitSetting.gameHoleTypeLimit = action.payload.gameHoleTypeLimit;
        state.limitSetting.playerCountLimit = action.payload.playerCountLimit;
        state.limitSetting.drivingRangeTimeLimit = action.payload.drivingRangeTimeLimit;
    },

    // 클라이언트 정보
    [ClientStatusInfo.LOAD_CLIENT_STATUS_INFO_REQUEST]: (state, action) => {
        state.error = INITIAL_STATE.error;
    },
    [ClientStatusInfo.LOAD_CLIENT_STATUS_INFO_SUCCESS]: (state, action) => {
        let gameMode = 'NoLimit';
        if (action.payload.gameTypeLimitCode === 1 || action.payload.gameTypeLimitCode === 2) {
            gameMode = 'Stroke';
        } else if (action.payload.gameTypeLimitCode === 0 || action.payload.gameTypeLimitCode === 3 || action.payload.gameTypeLimitCode === 4 || action.payload.gameTypeLimitCode === 5) {
            gameMode = 'DrivingRange';
        }

        state.clientGuid = action.payload.clientGuid;

        state.data.clientName = action.payload.clientName;
        state.data.clientTypeCode = action.payload.clientTypeCode;
        state.data.clientOrder = action.payload.clientOrder;
        state.data.realTimeStatusCode = action.payload.realTimeStatusCode;
        state.data.realTimeStatus = action.payload.realTimeStatus;
        state.data.startTime = action.payload.startTime;
        state.data.endTime = action.payload.endTime;
        state.data.usageTime = action.payload.usageTime;
        state.data.isContentLimit = action.payload.isContentLimit;
        state.data.paymentTypeCode = action.payload.paymentTypeCode;
        state.data.paymentType = action.payload.paymentType;
        state.data.gameMode = gameMode;
        state.data.gameTypeLimitCode = action.payload.gameTypeLimitCode;
        state.data.gameTypeLimit = action.payload.gameTypeLimit;
        state.data.gameHoleTypeLimit = action.payload.gameHoleTypeLimit;
        state.data.playerCountLimit = action.payload.playerCountLimit;
        state.data.drivingRangeTimeLimit = action.payload.drivingRangeTimeLimit;
        state.data.extendedTimeLimit = action.payload.extendedTimeLimit;
        state.data.serviceTimeLimit = action.payload.serviceTimeLimit;
        state.data.gameRoundId = action.payload.gameRoundId;
        state.data.loginPlayerCount = action.payload.loginPlayerCount;
        state.data.courseName = action.payload.courseName;
        state.data.completeHoleCount = action.payload.completeHoleCount;
        state.data.playHoleNumber = action.payload.playHoleNumber;
        state.data.gameRoundEstimatedEndTime = action.payload.gameRoundEstimatedEndTime;
        state.data.coursePlanId = action.payload.coursePlanId;

        state.limitSetting.paymentType = action.payload.paymentTypeCode;
        state.limitSetting.usageTime = action.payload.usageTime;
        state.limitSetting.isContentLimit = action.payload.isContentLimit;
        state.limitSetting.gameMode = gameMode;
        state.limitSetting.gameTypeLimit = action.payload.gameTypeLimitCode;
        state.limitSetting.gameHoleTypeLimit = action.payload.gameHoleTypeLimit;
        state.limitSetting.playerCountLimit = action.payload.playerCountLimit;
        state.limitSetting.drivingRangeTimeLimit = action.payload.drivingRangeTimeLimit;
    },
    [ClientStatusInfo.LOAD_CLIENT_STATUS_INFO_FAILURE]: (state, action) => {
        state.error = {
            triggered: true,
            message: action.payload.errorMessage,
        };
    },

    // 게임 라운드 설정
    [ClientStatusInfo.LOAD_GAME_ROUND_SETTING_REQUEST]: (state, action) => {
        state.error = INITIAL_STATE.error;
    },
    [ClientStatusInfo.LOAD_GAME_ROUND_SETTING_SUCCESS]: (state, action) => {
        state.clientInfo.gameRoundSetting.concede = `${action.payload.concede}`;
        state.clientInfo.gameRoundSetting.holeCupLocation = `${action.payload.holeCupLocation}`;
        state.clientInfo.gameRoundSetting.mulliganCount = `${action.payload.mulliganCount}`;
        state.clientInfo.gameRoundSetting.useSwingPlate = `${action.payload.useSwingPlate}`;
        state.clientInfo.gameRoundSetting.distanceUnit = `${action.payload.distanceUnit}`;
        state.clientInfo.gameRoundSetting.greenLocation = `${action.payload.greenLocation}`;
        state.clientInfo.gameRoundSetting.greenSpeed = `${action.payload.greenSpeed}`;
        state.clientInfo.gameRoundSetting.greenHardness = `${action.payload.greenHardness}`;
        state.clientInfo.gameRoundSetting.windSpeed = `${action.payload.windSpeed}`;
        state.clientInfo.gameRoundSetting.isUseGuideDistance = `${action.payload.isUseGuideDistance}`;
    },
    [ClientStatusInfo.LOAD_GAME_ROUND_SETTING_FAILURE]: (state, action) => {
        state.error = {
            triggered: true,
            message: action.payload.errorMessage,
        };
    },
});

export default reducer;
